import Link from 'next/link'
import { categoryName } from '@components/blog/utils/post'
import { tagLink, dateLink, categoryLink } from '@components/blog/utils/postLinks'
import simpleDate from '@utils/date/simpleDate'
import mix from '@utils/styles/mix'

import styles from '@components/blog/styles/PostMeta.module.css'

function PostMeta (post) {
    const { author, tags, created, className = '' } = post

    const catName = categoryName(post)
    const catLink = categoryLink(post)

    const postDateLink = dateLink(post)

    return (
        <div className={mix([styles.meta, className])}>
            <Link href={catLink}><a><b className={styles.category}>{ catName }</b></a></Link>
            { postTagList(tags) }
            <Link href={postDateLink}><a>{ time(created) }</a></Link>
            <address rel="author">{ author }</address>
        </div>
    )
}

function time (timestamp) {
    const datetimeText = simpleDate(timestamp)
    const datetimeAttr = simpleDate(timestamp, true)

    return <time dateTime={datetimeAttr}>{ datetimeText }</time>
}

function postTagList (tags = []) {
    if (!Array.isArray(tags)) return null
    const nonEmpty = tags.filter(Boolean)
    if (nonEmpty.length < 1) return null

    return (
        <ul className={styles.tags}>
            {
                nonEmpty.map(tag => (
                    <li key={tag}>{ postTag(tag) }</li>
                ))
            }
        </ul>
    )
}

function postTag (tag) {
    return tag
        ? <Link href={tagLink(tag)}><a>{ tag }</a></Link>
        : null
}

export default PostMeta